import { createSelector } from 'reselect'
import { IModalsState } from 'apps/fleet-planner/types/base'
import { IStore } from 'apps/fleet-planner/utils/types/store'

export const modalsStateSelector = (state: IStore): IModalsState => state.modals

export const modalInfoSelector = createSelector(
  modalsStateSelector,
  ({ actionInProgress, drivers, error, isDriverOptInModalOpen, shareLoads }) => ({
    error,
    actionInProgress,
    isDriverOptInModalOpen,
    drivers,
    shareLoads,
  })
)
